export const actionTypes = {
  SELECT_PAGINATION_LIMIT: 'SELECT_PAGINATION_LIMIT',
  RESET_PAGINATION_LIMIT: 'RESET_PAGINATION_LIMIT',
};

export const selectPaginationLimit = ({ rowPerPagination }) => ({
  type: actionTypes.SELECT_PAGINATION_LIMIT,
  rowPerPagination,
});
